import styled from "styled-components"

const ContentWrapper = styled.div`
  /* background-color: #60686f; */
  color: #ffffff;
  border-top: 2px solid white;
  padding-top: 20px;
  padding-bottom: 20px;
`

export default ContentWrapper
